const namespace = 'transactions';

export const FETCH_TRANSACTIONS = `${namespace}/FETCH_TRANSACTIONS`;
export const CREATE_TRANSACTION = `${namespace}/CREATE_TRANSACTION`;
export const SET_TRANSACTIONS_SORT_ORDER = `${namespace}/SET_TRANSACTIONS_SORT_ORDER`;
export const SET_TRANSACTIONS_IDS = `${namespace}/SET_TRANSACTIONS_IDS`;
export const SET_TRANSACTIONS_SELECTED_TAB = `${namespace}/SET_TRANSACTIONS_SELECTED_TAB`;
export const SET_TRANSACTIONS_PAGE = `${namespace}/SET_TRANSACTIONS_PAGE`;
